<template>
  <i class="iconfont" :class="fontClass"></i>
</template>

<script>
const classMap = {
  home: "icon-zhuye",
  QQ: "icon-QQ",
  wei: "icon-weixin",
  xinxi: "icon-xinxi",
  inter: "icon-wangluo",
  yonghu: "icon-yonghu",
  shezi: "icon-shezhi",
  phone:"icon-dianhua1",
  jiantou_xia:"icon-arrow-down-5",
  chanpin:"icon-chanpin",
  wenhua:"icon-qiyewenhua",
  hangye:"icon-hangyexiehui",
  qiche:"icon-qicheyuqichelingbujian",
  xingnengyuan:"icon-xinnengyuanqiche",
  qita:"icon-qitachanpin",
  jiantou:"icon-jiantouyou",
  close:"icon-cancel-1-copy",
};
export default {
    props:{
        type:{
            type: String,
            required: true,
        }

    },
    computed: {
        // 图标类样式
        fontClass() {
        return classMap[this.type];
        },
    },
}
</script>

<style scoped>
@import "//at.alicdn.com/t/c/font_4413224_8ph5kan4tl.css";

</style>